export default [
    {
        path: '/sent-requests',
        name: 'sent-requests',
        component: () => import('@/views/request/sent/Requests.vue'),
    },
    {
        path: '/sent-requests/:id',
        name: 'sent-request',
        component: () => import('@/views/request/sent/Request.vue'),
        props: (route) => {
            return route.params;
        }
    },

    {
        path: '/received-requests',
        name: 'received-requests',
        component: () => import('@/views/request/received/Requests.vue'),
    },
    {
        path: '/received-requests/:id',
        name: 'received-request',
        component: () => import('@/views/request/received/Request.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/received-requests/:id/forward',
        name: 'forward-request',
        component: () => import('@/views/request/ForwardRequest.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/requests/email-options',
        name: 'request-email-options',
        component: () => import('@/views/request/RequestEmailOptionsStep.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/received-requests/:id/forward/confirmation',
        name: 'forward-request-confirmation',
        component: () => import('@/views/request/ForwardConfirmation.vue'),
        props: (route) => {
            return route.params;
        }
    },
];
